// eslint-disable-next-line vue-component-file-name-match/match-component-import-name
import KaComboboxBase from './KaCombobox.vue';
import KaComboboxGroup from './KaComboboxGroup.vue';
import KaComboboxOption from './KaComboboxOption.vue';
import KaComboboxVee from './KaComboboxVee.vue';

export { type KaComboboxCreateOptionConfig, type KaComboboxProps } from './KaCombobox.vue';
export type { KaComboboxGroupProps, KaComboboxOptionProps } from './types';

Object.assign(KaComboboxBase, {
  Option: KaComboboxOption,
  Group: KaComboboxGroup,
});

export const KaCombobox = KaComboboxBase as typeof KaComboboxBase & {
  readonly Option: typeof KaComboboxOption;
  readonly Group: typeof KaComboboxGroup;
};

export { KaComboboxGroup, KaComboboxOption, KaComboboxVee };
